<template>
  <div>
    <v-radio :label="location" :value="value" color="secondary lighten-1">
    </v-radio>
    <div v-show="enableView">
      <layer-opacity
        ref="layerOpacity"
        :initialOpacity="initialOpacity"
        @changeOpacitySublayer="changeOpacitySublayer($event)"
      >
      </layer-opacity>

      <div class="mx-7">
        <div style="display: flex; align-items: center">
          <h4
            class="my-1"
            style="font-weight: normal; font-size: 14px; line-height: 18px"
          >
            Satélite:
          </h4>

          <v-tooltip color="primary darken-1" nudge-left="300" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary lighten-1">
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <div class="py-3">
              <div v-for="(satellite, index) in satellites" :key="index">
                <strong>{{ satellite.title }}: </strong>
                <span>{{ satellite.description }}</span>
              </div>
            </div>
          </v-tooltip>
        </div>
        <v-btn-toggle
          style="border-radius: 4px"
          mandatory
          v-model="satelliteType"
          @change="changeSatelliteType"
        >
          <v-btn
            v-for="(item, index) in satellites"
            :key="index"
            class="button-text satelliteButton"
            max-height="40"
            color="secondary lighten-1"
          >
            {{ item.title }}
          </v-btn>
        </v-btn-toggle>
      </div>

      <animation-player
        ref="animationPlayer"
        :timeFeatures="timeFeatures"
        dateFormat="'DD/MM/YYYY'"
        @changeTimeFeature="changeTimeFeature($event)"
      >
        <template v-slot:labelSelect> Data da imagem: </template>
      </animation-player>
    </div>
  </div>
</template>

<script>
import LayerOpacity from "../LayerOpacity.vue";
import AnimationPlayer from "../AnimationPlayer.vue";
export default {
  name: "RadioButtonSublayer",
  props: [
    "location",
    "value",
    "enableView",
    "initialOpacity",
    "timeFeatures",
    "satellites",
  ],
  components: {
    LayerOpacity,
    AnimationPlayer,
  },
  data: () => ({
    satelliteType: undefined,
    opacity: undefined,
    timeFeature: undefined,
  }),
  created() {
    this.satelliteType = 0;
  },
  watch: {
    enableView(value) {
      this.$refs.animationPlayer.clearAnimationInterval();
      if (value) {
        this.emitCurrentState();
      }
    },
  },
  methods: {
    changeOpacitySublayer(opacity) {
      this.opacity = opacity;
      this.$emit("changeOpacitySublayer", opacity);
    },
    changeTimeFeature(timeFeature) {
      this.timeFeature = timeFeature;
      this.$emit("changeTimeFeature", timeFeature);
    },
    changeSatelliteType(satellite) {
      this.$emit("changeSatelliteType", this.satellites[satellite].name);
    },
    emitCurrentState() {
      this.$emit("currentState", {
        location: this.location,
        opacity: this.$refs.layerOpacity?.opacitySublayer,
        timeFeature: this.$refs.animationPlayer?.timeFeatureSelect,
        satellite: this.satellites[this.satelliteType].name,
      });
    },
  },
};
</script>

<style scoped>
.satteliteButton {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
}
</style>
